import { InjectionToken } from '@angular/core';

export const SPEED_UNIT = new InjectionToken<string>('speedUnit');
